import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useSelfScheduleContext } from "@/contexts/self-schedule-provider";
import { cx } from "@/lib/tailwind-utils";
export function Completion(t0) {
  const $ = _c(7);
  const {
    children,
    className,
    testId
  } = t0;
  const {
    playNextStepAnimation
  } = useSelfScheduleContext();
  const t1 = playNextStepAnimation ? "motion-preset-confetti" : "motion-scale-in-105 motion-opacity-in-85";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cx("m-auto max-w-md motion-ease-spring-bouncy", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2 || $[5] !== testId) {
    t3 = <div data-testid={testId} className={t2}>{children}</div>;
    $[3] = children;
    $[4] = t2;
    $[5] = testId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export function CompletionHeader(t0) {
  const $ = _c(15);
  const {
    title,
    children
  } = t0;
  const {
    playNextStepAnimation
  } = useSelfScheduleContext();
  const t1 = !playNextStepAnimation && "motion-preset-confetti";
  let t2;
  if ($[0] !== t1) {
    t2 = cx("relative mb-5 flex h-24 w-24 items-center justify-center motion-scale-in-105 motion-delay-500", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="absolute inset-0 animate-ping rounded-full bg-status-success-bg opacity-40" />;
    t4 = <span className="absolute inset-2 rounded-full bg-status-success-bg" />;
    t5 = <FaCheckCircle className="relative h-14 w-14 text-status-success-text" />;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t2) {
    t6 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[5] = t2;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== title) {
    t7 = <h1 className="text-h1 tracking-tight text-foreground motion-opacity-in-85">{title}</h1>;
    $[7] = title;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== children) {
    t8 = <div className="mt-1.5 text-body text-foreground-secondary motion-opacity-in-85 motion-delay-[200ms]">{children}</div>;
    $[9] = children;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t7 || $[13] !== t8) {
    t9 = <div className="motion-preset-slide-right-sm flex flex-col items-center justify-center pb-6 pt-2 text-center">{t6}{t7}{t8}</div>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}